import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { CompanyType } from '../../../../core/constants/company-type.enum';
import { BUSINESS_ACTVITY_TYPE_MAP } from '../../../../features/application/constants/business-activity-type.enum';
import { MessageHelper } from '../../../../core/helpers/message-helper';
import { CompanyNameHelper } from '../../../../core/helpers/company-name-helper';
import { INVESTMENT_BUSINESS_ACTIVITY_MAP } from '../../../constants/nature-of-buisness.const';
import { BusinessActivityCode, StateNatureOfBusiness } from '../../../models/nature-of-business.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-nature-of-business-section',
    templateUrl: './nature-of-business-section.component.html',
    styleUrls: ['./nature-of-business-section.component.scss'],
    standalone: false
})
export class NatureOfBusinessSectionComponent implements OnInit, OnDestroy {
  @Input() natureOfBusiness?: StateNatureOfBusiness;
  @Input() opfCode?: CompanyType;
  @Input() hasInprinciple: boolean = false;

  //@ts-ignore
  fullName: string;
  //@ts-ignore
  fullNameKz: string;
  //@ts-ignore
  fullNameRu: string;

  //@ts-ignore
  fullAbbrName: string;
  //@ts-ignore
  fullAbbrNameKz: string;
  //@ts-ignore
  fullAbbrNameRu: string;

  //@ts-ignore
  mainBusinessActivity: BusinessActivityCode;

  otherBusinessActivities: {share: number, data: BusinessActivityCode}[] = [];

  subscription =  new Subscription();

  readonly MONTHS = [
    '',
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  constructor(private shared: SharedService) {
  }

  ngOnInit(): void {
    this.setFullName();
    this.setActivityCodes();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setActivityCodes(): void {
    this.mainBusinessActivity = this.shared.codes.find(code => code.id === this.natureOfBusiness!.mainBusinessActivityCodeId)!;

    this.otherBusinessActivities = [];
    this.natureOfBusiness!.otherBusinessActivityCodes?.forEach((activity) => {
    let data = this.shared.codes.find(code => code.id === activity.businessActivityCodeId);
      if (data) {
        this.otherBusinessActivities.push({
            share: activity.businessActivityCodeShare,
            data: data
        });
      }
    });
  }

  /**
   * Each of the six names is composed on its own: registered entities come back with the
   * endings already folded into the names and every `*Ending*` field null, so a language whose
   * ending is missing must still render its stem, and a missing English abbreviation must not
   * suppress the Ru/Kz ones.
   */
  private setFullName(): void {
    const nob = this.natureOfBusiness;
    this.fullName = CompanyNameHelper.compose(nob?.name, nob?.nameEnding) ?? '';
    this.fullNameRu = CompanyNameHelper.compose(nob?.nameRu, nob?.nameEndingRu) ?? '';
    this.fullNameKz = CompanyNameHelper.compose(nob?.nameKz, nob?.nameEndingKz) ?? '';

    this.fullAbbrName = CompanyNameHelper.compose(nob?.abbreviatedName, nob?.abbreviatedNameEnding) ?? '';
    this.fullAbbrNameRu = CompanyNameHelper.compose(nob?.abbreviatedNameRu, nob?.abbreviatedNameEndingRu) ?? '';
    this.fullAbbrNameKz = CompanyNameHelper.compose(nob?.abbreviatedNameKz, nob?.abbreviatedNameEndingKz) ?? '';
  }

  getBusinessActivityTypeTitle(): string {
    let id = this.natureOfBusiness?.businessActivityType?.[0];
    return BUSINESS_ACTVITY_TYPE_MAP.get(Number(id)) || 'Unknown';
  }

  get financialYearEndText(): string {
    return MessageHelper.GetTextForDayAndMonth(this.natureOfBusiness!.financialYearEndDay, this.natureOfBusiness!.financialYearEndMonth);
  }

  get businessSizeText(): string {
    return this.capitalizeFirst(this.natureOfBusiness!.businessSize || '');
  }


  private capitalizeFirst(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  isRco(): boolean {
    let list = [CompanyType.RCO, CompanyType.RGP, CompanyType.RLP, CompanyType.RPA];
    return list.includes(this.opfCode!);
  }

  isFou(): boolean {
    return this.opfCode == CompanyType.FOU;
  }

  get recognizedFormText(): string {
    return this.natureOfBusiness!.formOfRecognisedCompany == "BRANCH" ? "Branch" : 'Representative Office';
  }

  get investmentBusinessActivityText(): string {
    return INVESTMENT_BUSINESS_ACTIVITY_MAP.get(this.natureOfBusiness!.investmentBusinessActivityType!) || 'Unknown';
  }

  isInvestCompany(): boolean {
    return this.hasInprinciple 
      ? true
      :  this.opfCode == CompanyType.PRPC || this.opfCode == CompanyType.PUPC || this.opfCode == CompanyType.SPC
        || this.opfCode == CompanyType.LPA;
  }
}